<template>
    <div class="band-mobile-page" v-if="isShow">
        <mt-header fixed title="绑定手机号" style="background:#ffffff;color:#262626;">
            <router-link to="/login" slot="left">
                <mt-button icon="back"></mt-button>
            </router-link>
            <mt-button slot="right" @click="skip" class="skip">跳过</mt-button>
        </mt-header>

        <div class="main-section">
            <div class="box input regionNum" @click="show">
              <span>{{country}}</span>
              <span>
                +{{code}}
                <div class="arrow"></div>
              </span>
            </div>
            <div class="box input phone">
              <input type="text" placeholder="请输入手机号" v-model="phone">
            </div>
            <div class="box input code">
              <input type="text" placeholder="请输入验证码" v-model="password">
              <span v-show="sms_show" @click.stop="getSms">获取验证码</span>
              <span class="count_down"  v-show="!sms_show">{{count}}秒后重发</span>
            </div>
            <div class="box login" @click="bindPhone" :class="{'login_able':goSubmit}">绑定手机号</div>
            <p class="tips">绑定手机号后能更及时的获得更新的服务进度信息，并能获得更快速更便捷的技术支持</p>
        </div>
        <AwesomePicker  ref="pickers" :data="picker.slot" :textConfirm="picker.textConfirm"  :colorConfirm="picker.colorConfirm" :colorCancel="picker.colorCancel" @confirm="handlePickerConfirm"></AwesomePicker >
    </div>
 
</template>

<script>
import axios from 'axios';
import picker from 'vue-3d-picker';
import AwesomePicker  from '../assets/lib/awesome-picker'
import { Popup,Indicator,Spinner,MessageBox,Picker } from 'mint-ui';
import Qs from 'qs'

export default {
    name:"login",
    metaInfo: {
        title: '果师兄官网_苹果手机数据恢复|微信聊天记录恢复|电脑数据恢复', // set a title
        meta: [{                 // set meta
          name: 'keyWords',
          content: '果师兄恢复大师,苹果数据恢复软件,手机数据恢复软件,电脑数据恢复'
        },{                 // set meta
          name: 'description',
          content: '果师兄恢复大师为用户提供电脑手机数据恢复服务,主要服务包括微信聊 天记录,短信,备忘录,微信好友添加,照片等苹果手机数据恢复,回收站清空文件恢复,U 盘/硬 盘/SD 卡/储存卡等各类存储设备数据恢复,以及相关的数据迁移、数据删除等指导服务'
        }]
    },
    data(){
        return{
            picker:{
                slot:[],
                textConfirm:"完成",
                colorConfirm:"#3189FF",
                colorCancel:"#3189FF"
            },
            password:"",
            phone:"",
            popupVisible:false,
            country:"中国大陆",
            code:"86",
            code_options:"",
            country_options:"",
            sms_show:true,//是否能获取验证码
            smsAble:false,
            count:"59",
            slots:[
                {
                    flex: 1,
                    values: [],
                    className: 'slot1',
                    textAlign: 'center'
                }
            ],
            countryCodes:[],
            goSubmit:false,
            country_arr:[],
            nextPath: '',
            isShow: false
        }
    },
    methods:{
        skip(){
            this.$router.replace({name:this.nextPath})
        },
        show() {
            this.$refs.pickers.show();
        },
        handlePickerConfirm(item){
            this.country = this.country_arr[item[0].index].country;
            this.code = this.country_arr[item[0].index].code;
            this.validInput();
            
        },
        onValuesChange(picker, values) {
            let arr =  values.join().split(" ");
            this.code_options = arr[0].replace("+","");
            this.country_options = arr[arr.length-1];
            
        },
        validInput(){
            this.phone = this.phone.replace(/\s+/g, "");
            if(this.code != 86){
                var reg_phone = /^\d{6,}$/;
            }else{
                var reg_phone = /^1\d{10}$/;
            }
            if(reg_phone.test(this.phone)){
                this.smsAble = true;
            }else{
                this.smsAble = false;
            }
            
            if(this.phone && reg_phone.test(this.phone) && this.password){
                this.goSubmit = true;
            }else{
                this.goSubmit = false;
                
            }
        },
        chooseCode(){
            if(!this.code_options || !this.country_options){
                return
            }
            this.code = this.code_options;
            this.country = this.country_options;
            this.popupVisible = false;
        },
        getCountryCodes(){
            var vm = this;
            this.$store.dispatch("getCountryCodes").then((res)=>{
                var result = res.data;
                if(result.code == 0){
                    let countryCodes = result.res;
                    vm.country_arr = countryCodes;
                    let arr1 = [];
                    for(let i=0;i<countryCodes.length;i++){
                        let code = `<span class="country_code">+${countryCodes[i].code}</span><span class="country_name">${countryCodes[i].country}</span>`;
                        arr1.push(code)
                    }
                    vm.picker.slot.push(arr1)
                   
                }
            })
        },
        getSms(){
            if(!this.smsAble){
                return
            }
            var vm = this;
            this.count = 59;
            if(this.code != 86){
                var reg_phone = /^\d{6,}$/;
            }else{
                var reg_phone = /^1\d{10}$/;
            }
            if(!vm.phone.replace(/\s+/g, "")){
                this.$toastlj("请输入手机号码")
                return
            }
            if(!reg_phone.test(vm.phone.replace(/\s+/g, ""))){
                this.$toastlj("请输入正确的手机号码")
                return
            }
            
            let info = {
               'phone':vm.phone,
               'country_code':vm.code,
               'type':3,
               'app_id':window.config.appid,
              
            }
            this.$store.dispatch("getSms",info).then((res)=>{
                var result = res.data;
                if(result.code == 0){
                     vm.countDown();
                     vm.sms_show = false;
                }
               
               
            })
        },
        countDown(){
            let vm = this;
            let interval = setInterval(function(){
                vm.count = vm.count -1;
                if(vm.count == 0){
                    vm.sms_show = true;
                    window.clearInterval(interval);  
                }
            },1000)
        },
        bindPhone(){
            if(!this.goSubmit){
                return
            }
            
            var vm = this;
            if(this.code != 86){
                var reg_phone = /^\d{6,}$/;
            }else{
                var reg_phone = /^1\d{10}$/;
            }
            if(!vm.phone.replace(/\s+/g, "")){
                this.$toastlj("请输入手机号码")
                Indicator.close();
                return
            }
            if(!reg_phone.test(vm.phone.replace(/\s+/g, ""))){
                this.$toastlj("请输入正确的手机号码")
                Indicator.close();
                return
            }
            if(!vm.password.replace(/\s+/g, "")){
                this.$toastlj("请输入验证码")
                return
            }
            Indicator.open('绑定中...');
            let access_token = localStorage.access_token
            let info = {
                phone:vm.phone.replace(/\s+/g, ""),
                country_code:vm.code.replace(/\s+/g, ""),
                code:vm.password.replace(/\s+/g, ""),
                access_token: access_token
            };
            this.$store.dispatch("bindPhone",info).then((res)=>{
                var result = res.data;
                if(result.code == 0){
                    Indicator.close();
                    vm.$router.push({name:"home"})
                }else if(result.code == 1300){
                    vm.$toastlj('验证码错误')
                    Indicator.close();

                }else{
                    vm.$toastlj(result.message)
                    
                }
            })
        }
    },
 
    created(){
        this.getCountryCodes();
        let hash = this.$route.hash
        
        let arr = hash.split("#")[1].split("&");   //先通过？分解得到？后面的所需字符串，再将其通过&分解开存放在数组里
        let obj = {};
        for (let i of arr) {
            obj[i.split("=")[0]] = i.split("=")[1];  //对数组每项用=分解开，=前为对象属性名，=后为属性值
        }
        let data = {
            access_token: obj.access_token,
            app_id: window.config.appid
        }
        let vm = this
        this.$store.dispatch('loginQQ',data).then((res)=>{
            let result = res.data
            if(result.code == 0){
                let userinfo = result.res.userinfo
                localStorage.kxuid = userinfo.kxuid
                localStorage.nickname = userinfo.user_nickname
                localStorage.bind_phone = userinfo.user_bind_phone
                localStorage.email = userinfo.user_bind_email
                localStorage.removeItem("login_first")

                let token = result.res.token
                localStorage.access_token = token.access_token;
                localStorage.expire_time = token.expire_time*1000;
                localStorage.refresh_expire_time = token.refresh_expire_time;
                localStorage.refresh_token = token.refresh_token;

                this.nextPath = obj.state
                if(userinfo.user_bind_phone){
                    vm.$router.replace({name:this.nextPath})
                }else {
                    vm.isShow = true
                }
            }else{
                vm.$toastlj(result.message)
            }
        })
    },
    mounted(){
        Indicator.close();
    },
    watch: {
        phone: function(value) {
            this.validInput()
        },
        password: function (value) {
            this.validInput()
        }
    },
    components:{
        Picker,
        Popup,
        Indicator,
        
        picker,
        AwesomePicker
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/BandMobile.vue